import { useIntl } from "react-intl";

// This function can be used to translate if we need the text rather then html
const TranslateIntl = (id, values) => {
  const intl = useIntl();

  return intl.formatMessage({ id }, values);
};

export default TranslateIntl;
